import { ChangeDetectorRef, Component } from '@angular/core';
import { OccEndpointsService, UserIdService } from '@spartacus/core';
import { CommonApiService } from '../../spartacus/services/common-api.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-custom-info',
    templateUrl: './custom-info.component.html',
    styleUrls: ['./custom-info.component.scss'],
    standalone: false
})
export class CustomInfoComponent {
  concentDetails: any
  toggleEdit: boolean = false;
  consent: boolean = false;
  userId: string='';
  constructor(private occEndpointsService: OccEndpointsService,private userInfoService:UserInfoService,
    private commonService: CommonApiService, private cd:ChangeDetectorRef,private userIdService:UserIdService) {

  }
  edit() {
    this.toggleEdit = !this.toggleEdit;
  }
  ngOnInit() {
    this.getConcentDetails();
  }
  getConcentDetails() {

    this.userInfoService.getconsentus().subscribe(
      (data) => {
        if (data) {
         
          this.concentDetails=data;
       
          this.cd.detectChanges();
        }
       
      },
      (error) => {
        console.log('error');
       
      }
    );
  
   /*  let endpoint = this.occEndpointsService.buildUrl(`/users/${this.commonService.userId}/my-profile/isConsentGranted`);
    let payload = {
      url: endpoint,
    }
    this.concentDetails$ = this.commonService.getAPICall(payload); */
  }
  getValue(value: boolean) {
    this.consent = value;
  }
  submitConcent() {
    this.userIdService.getUserId().subscribe(item => {
      if(item){
        this.userId = item;
      }
    });
    let endpoint = this.occEndpointsService.buildUrl(`/users/${this.userId}/my-profile/marketingconsent/${this.consent}`);
    let payload: any = {
      url: endpoint,
    }
    this.commonService.postAPICall(payload).subscribe(res => {
      this.toggleEdit=false;
      this.getConcentDetails();
      this.cd.detectChanges();
    });

  }
}
